import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ExternalProviderInfoFragment = { providerId: string, meta: string, creationStrategy?: Types.ExternalEventCreationStrategyEnum | null, provider?: { id: string, name: string, externalEventCreationStrategies: Array<Types.ExternalEventCreationStrategyEnum>, logo: { url?: string | null }, formInputs?: Array<{ label: string, name: string, placeholder?: string | null, type: Types.FormComponentFieldTypeEnum }> | null } | null };


export type ExternalProviderInfoFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ExternalProviderInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment ExternalProviderInfo on ExternalEventProviderInfoType {
  providerId
  meta
  creationStrategy
  provider {
    id
    name
    logo {
      url
    }
    formInputs {
      label
      name
      placeholder
      type
    }
    externalEventCreationStrategies
  }
}
    `;